import { Base } from '../base-component';

import './cross-sell-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

export class CrossSellItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/cross-sell-item/cross-sell-item.component.ts